module.exports = __webpack_public_path__ + "img/panelView_baoSteel_4_3.d920893c.png";